import { render, staticRenderFns } from "./ChannelUserTable.vue?vue&type=template&id=bdef44a8&scoped=true&"
import script from "./ChannelUserTable.vue?vue&type=script&lang=ts&"
export * from "./ChannelUserTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdef44a8",
  null
  
)

export default component.exports